import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CtaButtonProps = {
  label: string;
  subLabel?: string;
  id?: string;
  variant?: 'primary' | 'onDark';
};
export function CtaButton({
  label,
  subLabel,
  id,
  variant = 'primary'
}: CtaButtonProps) {
  const base = 'group flex w-full items-center justify-center gap-2 rounded-2xl px-5 py-4 text-center text-[15px] font-extrabold uppercase leading-tight tracking-wide shadow-lg transition-[transform,background-color,box-shadow] duration-200 ease-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 active:translate-y-[1px] sm:text-lg sm:py-5';
  const styles = variant === 'onDark' ? 'bg-white text-navy hover:bg-skysoft shadow-black/30 focus-visible:outline-white' : 'bg-cta text-white hover:bg-ctahover shadow-cta/25 focus-visible:outline-cta';
  return <div id={id} className="w-full" data-id="element-70" data-mp="15arg8jogtjo5">
      <a href={CHECKOUT_URL} className={`${base} ${styles}`} data-id="element-71" data-mp="157dg7i39xmjv">
        <span className="max-w-[18ch] sm:max-w-none" data-id="element-72" data-mp="35yha66ewbc6s">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-73" data-mp="39y7wnxxe365i" />
      </a>
      {subLabel ? <p className={`mt-3 text-center text-[12.5px] leading-relaxed sm:text-sm ${variant === 'onDark' ? 'text-white/70' : 'text-navy2/70'}`} data-id="element-74" data-mp="3jxgp2mclwcpr">
          {subLabel}
        </p> : null}
    </div>;
}